import { render, staticRenderFns } from "./EmailMessagesView.vue?vue&type=template&id=153819b9&scoped=true&"
import script from "./EmailMessagesView.vue?vue&type=script&lang=js&"
export * from "./EmailMessagesView.vue?vue&type=script&lang=js&"
import style0 from "./EmailMessagesView.vue?vue&type=style&index=0&id=153819b9&prod&scoped=true&lang=css&"
import style1 from "./EmailMessagesView.vue?vue&type=style&index=1&id=153819b9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153819b9",
  null
  
)

export default component.exports